import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import {
  Row,
  Label,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  Button,
  ButtonGroup,
  TextField,
  Checkbox,
  Grid,
  Paper,
  Divider,
} from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";

import { makeStyles } from "@material-ui/core/styles";

import classNames from "classnames";

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import DisputeContext from "../../../context/paypal/disputes/DisputeContext";

const DisputeFilter = ({
  setDisputesItems,
  setFilterDataCounts,
  messagesClaimsSelected,
  setMessagesClaimsSelected,
  caseSelected,
  setCaseSelected,
  reasonSelected,
  setReasonSelected,
  sendStatusRequest,
  setSendStatusRequest,
  state,
  setState,
  monthSelected,
  setMonthSelected,
  // getReasonType,
}) => {
  const disputeContext = useContext(DisputeContext);
  const [sendTriggerRequest, setSendTriggerRequest] = useState([]);
  const [reasonList, setReasonList] = useState([]);
  const [statusButtonColor, setStatusButtonColor] = useState({
    seller: "#ffffff",
    review: "#ffffff",
    buyer: "#ffffff",
  });

  //Data Counters
  const [statusSellerCounts, setStatusSellerCounts] = useState(0);
  const [statusReviewCounts, setStatusReviewCounts] = useState(0);
  const [statusBuyerCounts, setStatusBuyerCounts] = useState(0);

  //Due date filter useState
  const [dateSelected, setDateSelected] = useState(new Date());
  const [calendarMonth] = useState([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]);

  //Dropdown Button Initiate State
  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [dropdownOpen3, setDropdownOpen3] = useState(false);
  const [dropdownOpen4, setDropdownOpen4] = useState(false);
  const [dropdownOpen5, setDropdownOpen5] = useState(false);
  const [dropdownOpen6, setDropdownOpen6] = useState(false);

  const toggle1 = () => setDropdownOpen1((prevState) => !prevState);
  const toggle2 = () => setDropdownOpen2((prevState) => !prevState);
  const toggle3 = () => setDropdownOpen3((prevState) => !prevState);
  const toggle4 = () => setDropdownOpen4((prevState) => !prevState);
  const toggle5 = () => setDropdownOpen5((prevState) => !prevState);
  const toggle6 = () => setDropdownOpen6((prevState) => !prevState);

  const { disputes, dispute, getDisputeById } = disputeContext;

  // References
  const got_orderRef = useRef(state.got_order);
  got_orderRef.current = state.got_order;

  // Convert date to GMT format function
  const dateFormat = (date) => {
    return new Intl.DateTimeFormat("en-GB", {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
      timeZone: "Asia/Kuala_Lumpur",
    }).format(new Date(date));
  };

  //Convert String to Camel Case
  const camelCaseFormat = (str) => {
    let str_split = str.toLowerCase().split("_");
    for (let i = 0; i < str_split.length; i++) {
      str_split[i] =
        str_split[i].charAt(0).toUpperCase() + str_split[i].substring(1);
    }
    return str_split.join(" ");
  };

  useEffect(() => {
    if (sendStatusRequest) {
      if (sendStatusRequest === "seller_response") {
        setStatusButtonColor({
          seller: "#dddddd",
          review: "#ffffff",
          buyer: "#ffffff",
        });
      } else if (sendStatusRequest === "under_review") {
        setStatusButtonColor({
          seller: "#ffffff",
          review: "#dddddd",
          buyer: "#ffffff",
        });
      } else if (sendStatusRequest === "buyer_response") {
        setStatusButtonColor({
          seller: "#ffffff",
          review: "#ffffff",
          buyer: "#dddddd",
        });
      } else {
        setStatusButtonColor({
          seller: "#ffffff",
          review: "#ffffff",
          buyer: "#ffffff",
        });
      }
    }
  }, [sendStatusRequest]);

  useEffect(() => {
    setSendTriggerRequest();
  }, []);

  useEffect(() => {
    if (disputes && Object.keys(disputes).length > 0) {
      // getDisputeById
      if (got_orderRef.current === false) {
        setState((state) => ({
          ...state,
          got_order: true,
        }));
      }
    } else {
      // Errors - no value return
      setState((state) => ({
        ...state,
        got_order: false,
      }));
    }
    //eslint-disable-next-line
  }, [disputes]);

  // Set data to Table after filtering
  useEffect(() => {
    var sellerCounts = 0;
    var reviewCounts = 0;
    var buyerCounts = 0;
    var filterCounts = 0;
    var reason_list = [];
    setReasonList(() => []);

    if (disputes) {
      //sort disputes by create_time
      const disputes_sorted = []
        .concat(disputes)
        .sort((a, b) => (a.create_time > b.create_time ? -1 : 1));

      setDisputesItems(() => []);
      for (let x in disputes_sorted) {
        let each = disputes_sorted[x];

        let due_date = "";
        const reason = camelCaseFormat(each.reason);
        const status = camelCaseFormat(each.status);
        //Change date format to GMT
        const create_time = dateFormat(each.create_time);
        const update_time = dateFormat(each.update_time);

        if (each.seller_response_due_date) {
          due_date = dateFormat(each.seller_response_due_date);
        } else if (each.buyer_response_due_date) {
          due_date = dateFormat(each.buyer_response_due_date);
        }

        let minValue = 0;
        let maxValue = 999999999;
        let caseInternal = "";
        let caseExternal = "";
        let messagesClaimsChargeback = "";
        let messagesClaimsPreArbitration = "";
        let messagesClaimsInquiry = "";
        let reason_selected = [];
        let duedate_filter = "";

        //Set duedate_filter
        if (
          state.day_value !== "" &&
          monthSelected.length > 0 &&
          state.year_value !== ""
        ) {
          duedate_filter =
            state.day_value + " " + monthSelected + " " + state.year_value;
        } else if (
          state.day_value === "" &&
          monthSelected.length > 0 &&
          state.year_value !== ""
        ) {
          duedate_filter = monthSelected + " " + state.year_value;
        } else if (
          state.day_value !== "" &&
          monthSelected.length > 0 &&
          state.year_value === ""
        ) {
          duedate_filter = state.day_value + " " + monthSelected;
        } else if (
          state.day_value !== "" &&
          monthSelected.length === 0 &&
          state.year_value === ""
        ) {
          duedate_filter = state.day_value + " ";
        } else if (
          state.day_value === "" &&
          monthSelected.length > 0 &&
          state.year_value === ""
        ) {
          duedate_filter = monthSelected + " ";
        } else if (
          state.day_value === "" &&
          monthSelected.length === 0 &&
          state.year_value !== ""
        ) {
          duedate_filter = state.year_value + ",";
        }

        //Set minimum and maximum value for filtering when input is not empty
        if (state.min_value !== "") {
          minValue = parseFloat(state.min_value);
        }
        if (state.max_value !== "") {
          maxValue = parseFloat(state.max_value);
        }

        //Set casetype based on Case type selected (default = all box checked)
        if (caseSelected.indexOf(1) >= 0) {
          caseInternal = "INTERNAL";
        }
        if (caseSelected.indexOf(2) >= 0) {
          caseExternal = "EXTERNAL";
        }

        //Set Messages and Claims based on checkbox selected (default = all box checked)
        if (messagesClaimsSelected.indexOf(1) >= 0) {
          messagesClaimsChargeback = "CHARGEBACK";
          messagesClaimsPreArbitration = "PRE_ARBITRATION";
        }
        if (messagesClaimsSelected.indexOf(2) >= 0) {
          messagesClaimsInquiry = "INQUIRY";
        }

        //Set reason based on Reason selected (default = all box checked)
        if (reason_list.indexOf(reason) < 0) {
          reason_list.push(reason);
        }
        for (let y = 0; y < reasonSelected.length; y++) {
          if (reasonSelected.indexOf(y + 1) >= 0) {
            reason_selected.push(reason_list[y]);
          }
        }

        //Get status counts
        if (each.status === "WAITING_FOR_SELLER_RESPONSE") {
          sellerCounts += 1;
        } else if (each.status === "UNDER_REVIEW") {
          reviewCounts += 1;
        } else if (each.status === "WAITING_FOR_BUYER_RESPONSE") {
          buyerCounts += 1;
        }

        //Set data to table based on all filtering
        if (
          each.dispute_life_cycle_stage === messagesClaimsChargeback ||
          each.dispute_life_cycle_stage === messagesClaimsPreArbitration ||
          each.dispute_life_cycle_stage === messagesClaimsInquiry
        ) {
          if (due_date.indexOf(duedate_filter) >= 0) {
            if (reason_selected.indexOf(reason) >= 0) {
              if (
                each.dispute_channel === caseInternal ||
                each.dispute_channel === caseExternal
              ) {
                if (
                  parseFloat(each.dispute_amount.value) >= minValue &&
                  parseFloat(each.dispute_amount.value) <= maxValue
                ) {
                  //Get Button Response (Seller, Under Review, Buyer)
                  if (sendStatusRequest === "seller_response") {
                    if (each.status === "WAITING_FOR_SELLER_RESPONSE") {
                      filterCounts += 1;
                      setDisputesItems((disputesItems) => [
                        ...disputesItems,
                        {
                          dispute_id: each.dispute_id,
                          reason: reason,
                          status: status,
                          amount:
                            each.dispute_amount.value +
                            " " +
                            each.dispute_amount.currency_code,
                          create_time: create_time,
                          update_time: update_time,
                          due_date: due_date,
                        },
                      ]);
                    }
                  } else if (sendStatusRequest === "under_review") {
                    if (each.status === "UNDER_REVIEW") {
                      filterCounts += 1;
                      setDisputesItems((disputesItems) => [
                        ...disputesItems,
                        {
                          dispute_id: each.dispute_id,
                          reason: reason,
                          status: status,
                          amount:
                            each.dispute_amount.value +
                            " " +
                            each.dispute_amount.currency_code,
                          create_time: create_time,
                          update_time: update_time,
                          due_date: due_date,
                        },
                      ]);
                    }
                  } else if (sendStatusRequest === "buyer_response") {
                    if (each.status === "WAITING_FOR_BUYER_RESPONSE") {
                      filterCounts += 1;
                      setDisputesItems((disputesItems) => [
                        ...disputesItems,
                        {
                          dispute_id: each.dispute_id,
                          reason: reason,
                          status: status,
                          amount:
                            each.dispute_amount.value +
                            " " +
                            each.dispute_amount.currency_code,
                          create_time: create_time,
                          update_time: update_time,
                          due_date: due_date,
                        },
                      ]);
                    }
                  } else {
                    filterCounts += 1;
                    setDisputesItems((disputesItems) => [
                      ...disputesItems,
                      {
                        dispute_id: each.dispute_id,
                        reason: reason,
                        status: status,
                        amount:
                          each.dispute_amount.value +
                          " " +
                          each.dispute_amount.currency_code,
                        create_time: create_time,
                        update_time: update_time,
                        due_date: due_date,
                      },
                    ]);
                  }
                }
              }
            }
          }
        }
        // Set Counts
        setStatusSellerCounts(sellerCounts);
        setStatusReviewCounts(reviewCounts);
        setStatusBuyerCounts(buyerCounts);
        setFilterDataCounts(filterCounts);
      }
    }
    //Set reason list for Reason Dropdown Box
    setReasonList(reason_list);
    //eslint-disable-next-line
  }, [
    disputes,
    state.f_value === "",
    sendStatusRequest,
    sendTriggerRequest,
    caseSelected,
    reasonSelected,
    monthSelected,
    messagesClaimsSelected,
  ]);

  //Search data by ID from database and set it to table
  useEffect(() => {
    if (dispute) {
      var due_date = "";
      const reason = camelCaseFormat(dispute.reason);
      var status = dispute.status.split("_").join(" ");
      const create_time = dateFormat(dispute.create_time);
      const update_time = dateFormat(dispute.update_time);

      if (dispute.seller_response_due_date) {
        due_date = dateFormat(dispute.seller_response_due_date);
      } else if (dispute.buyer_response_due_date) {
        due_date = dateFormat(dispute.buyer_response_due_date);
      }

      setFilterDataCounts(1);
      setDisputesItems(() => [
        {
          dispute_id: dispute.dispute_id,
          reason: reason,
          status: status,
          amount:
            dispute.dispute_amount.value +
            " " +
            dispute.dispute_amount.currency_code,
          create_time: create_time,
          update_time: update_time,
          due_date: due_date,
        },
      ]);
    }
    if (dispute && Object.keys(dispute).length > 0) {
      // getDisputeById
      if (got_orderRef.current === false) {
        setState((state) => ({
          ...state,
          got_order: true,
        }));
      }
    } else {
      // Errors - no value return
      setState((state) => ({
        ...state,
        got_order: false,
      }));
    }
    //eslint-disable-next-line
  }, [dispute]);

  //Search Box (Dispute ID) filter
  const onFilterBy = (e) => {
    // #: This function is to set filter type and value to local state when user change.
    e.preventDefault();
    e.persist();

    const value = e.target.value.trim();
    // const validTransIdRegex = /^[A-Za-z0-9]+$/;
    const validTransIdRegex = /^[a-zA-Z0-9-]+$/g;

    if (e.target.id === "f_value") {
      let errors = state.errors;

      if (value === "" || validTransIdRegex.test(value)) {
        errors.f_value = "";
      } else {
        errors.f_value = "Invalid Dispute ID.";
      }

      setState((state) => ({
        ...state,
        [e.target.id]: value,
        errors: errors,
      }));
    }
  };

  // Search data by Dispute ID
  const onSearch = (e) => {
    // #: This function is to get dispute details from DB using search value given.
    e.preventDefault();
    getDisputeById(state.f_value);
  };

  //Filter Minimum Amount Input (Amount dropdown box)
  const onMinFilterBy = (e) => {
    e.preventDefault();
    e.persist();
    const value = e.target.value.trim();
    const validTransIdRegex = /^[0-9]+(\.[0-9][0-9]?)?$/g;
    if (e.target.id === "min_value") {
      let errors = state.errors;

      if (value === "" || validTransIdRegex.test(value)) {
        errors.min_value = "";
      } else {
        errors.min_value = "Invalid Minimum Amount";
      }

      setState((state) => ({
        ...state,
        [e.target.id]: value,
        errors: errors,
      }));
    }
    setTimeout(() => {
      setSendTriggerRequest(state.min_value);
    }, 300);
  };

  //Filter Maximum Amount Input (Amount dropdown box)
  const onMaxFilterBy = (e) => {
    e.preventDefault();
    e.persist();

    const value = e.target.value.trim();
    const validTransIdRegex = /^[0-9]+(\.[0-9][0-9]?)?$/g;

    if (e.target.id === "max_value") {
      let errors = state.errors;

      if (value === "" || validTransIdRegex.test(value)) {
        errors.max_value = "";
      } else {
        errors.max_value = "Invalid Maximum Amount";
      }

      setState((state) => ({
        ...state,
        [e.target.id]: value,
        errors: errors,
      }));
    }
    setTimeout(() => {
      setSendTriggerRequest(state.max_value);
    }, 300);
  };

  //Filter Day Input (Due date dropdown box)
  const onDayFilterBy = (e) => {
    e.preventDefault();
    e.persist();
    const value = e.target.value.trim();
    const validTransIdRegex = /^[0-9]{1,2}$/g;
    if (e.target.id === "day_value") {
      let errors = state.errors;

      if (value === "" || validTransIdRegex.test(value)) {
        errors.day_value = "";
      } else {
        errors.day_value = "Invalid Date Format";
      }

      setState((state) => ({
        ...state,
        [e.target.id]: value,
        errors: errors,
      }));
    }
    setTimeout(() => {
      setSendTriggerRequest(state.day_value);
    }, 300);
  };

  //Filter Year Input (Due date dropdown box)
  const onYearFilterBy = (e) => {
    e.preventDefault();
    e.persist();
    const value = e.target.value.trim();
    const validTransIdRegex = /^[0-9]{4}$/g;
    if (e.target.id === "year_value") {
      let errors = state.errors;

      if (value === "" || validTransIdRegex.test(value)) {
        errors.year_value = "";
      } else {
        errors.year_value = "Invalid Date Format";
      }

      setState((state) => ({
        ...state,
        [e.target.id]: value,
        errors: errors,
      }));
    }
    setTimeout(() => {
      setSendTriggerRequest(state.year_value);
    }, 300);
  };

  //Messages and Claims checkbox onChange
  const onMessagesAndClaimsCheckboxBtnClick = (selected) => {
    const index = messagesClaimsSelected.indexOf(selected);
    if (index < 0) {
      messagesClaimsSelected.push(selected);
    } else {
      messagesClaimsSelected.splice(index, 1);
    }
    setMessagesClaimsSelected([...messagesClaimsSelected]);
  };

  //Case type checkbox onChange
  const onCaseCheckboxBtnClick = (selected) => {
    const index = caseSelected.indexOf(selected);
    if (index < 0) {
      caseSelected.push(selected);
    } else {
      caseSelected.splice(index, 1);
    }
    setCaseSelected([...caseSelected]);
  };

  //Reason checkbox onChange
  const onReasonCheckboxBtnClick = (selected) => {
    const index = reasonSelected.indexOf(selected);
    if (index < 0) {
      reasonSelected.push(selected);
    } else {
      reasonSelected.splice(index, 1);
    }
    setReasonSelected([...reasonSelected]);
  };

  //Due date Calendar onClick
  const onDateSelected = (selected) => {
    var date_selected = new Intl.DateTimeFormat("en-GB", {
      year: "numeric",
      month: "long",
      day: "2-digit",
      timeZone: "Asia/Kuala_Lumpur",
    })
      .format(new Date(selected))
      .split(" ");

    state.day_value = date_selected[0];
    setMonthSelected(date_selected[1]);
    state.year_value = date_selected[2];
    setDateSelected(selected);
    setSendTriggerRequest(selected);
  };

  //Open Calendar Button (Duedate fiter)
  const CustomInput = ({ onClick }) => (
    <Button variant="contained" color="primary" onClick={onClick}>
      Calendar{" "}
    </Button>
  );

  //Clear filter button
  const clearFilter = (e) => {
    e.preventDefault();
    state.min_value = "";
    state.max_value = "";
    state.day_value = "";
    state.year_value = "";
    state.f_value = "";
    setSendTriggerRequest([]);
    setSendStatusRequest([]);
    setMonthSelected([]);
    setCaseSelected([1, 2]);
    setMessagesClaimsSelected([1, 2]);
    setReasonSelected([
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    ]);
  };

  const useStyles = makeStyles((theme) => ({
    paper: {
      padding: theme.spacing(1),
      textAlign: "left",
      color: theme.palette.text.secondary,
    },
    buttonOutline: {
      "&:focus": {
        outline: "none",
      },
    },
  }));

  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12}>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={5}>
              <TextField
                label="Dispute ID"
                variant="outlined"
                type="text"
                id="f_value"
                name="f_value"
                size="small"
                value={state.f_value}
                onChange={onFilterBy}
                className={classNames("form-control", {
                  "is-invalid": state.errors.f_value,
                })}
                style={{
                  zIndex: 0,
                }}
              />{" "}
            </Grid>{" "}
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                id="f_search"
                name="f_search"
                size="large"
                className={classes.buttonOutline}
                onClick={onSearch}
                disabled={
                  state.f_value && state.errors.f_value === "" ? false : true
                }
              >
                Search{" "}
              </Button>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Grid>{" "}
        <Grid item xs={12}>
          <Divider variant="fullWidth" />
        </Grid>{" "}
        <Grid item xs={12}>
          <Grid container direction="row" justifyContent="center">
            <ButtonGroup
              style={{
                width: "100%",
              }}
            >
              <Button
                style={{
                  width: "33.33%",
                  backgroundColor: statusButtonColor.seller,
                }}
                className={classes.buttonOutline}
                type="button"
                variant="outlined"
                onClick={() => setSendStatusRequest("seller_response")}
              >
                <strong> Seller </strong>&ensp;{" "}
                <strong
                  style={{
                    color: "red",
                  }}
                >
                  {" "}
                  ({statusSellerCounts}){" "}
                </strong>{" "}
              </Button>{" "}
              & ensp;{" "}
              <Button
                style={{
                  width: "33.33%",
                  backgroundColor: statusButtonColor.review,
                }}
                className={classes.buttonOutline}
                type="button"
                variant="outlined"
                onClick={() => setSendStatusRequest("under_review")}
              >
                <strong> Under Review </strong>&ensp;{" "}
                <strong
                  style={{
                    color: "red",
                  }}
                >
                  {" "}
                  ({statusReviewCounts}){" "}
                </strong>{" "}
              </Button>{" "}
              & ensp;{" "}
              <Button
                style={{
                  width: "33.33%",
                  backgroundColor: statusButtonColor.buyer,
                }}
                className={classes.buttonOutline}
                type="button"
                variant="outlined"
                onClick={() => setSendStatusRequest("buyer_response")}
              >
                <strong> Buyer </strong>&ensp;{" "}
                <strong
                  style={{
                    color: "red",
                  }}
                >
                  {" "}
                  ({statusBuyerCounts}){" "}
                </strong>{" "}
              </Button>{" "}
            </ButtonGroup>{" "}
          </Grid>{" "}
        </Grid>{" "}
        <Grid item xs={12}>
          <Divider variant="fullWidth" />
        </Grid>{" "}
        <Grid item xs={12}>
          {" "}
          {/* Other Filters Dropdown Box */}{" "}
          <Grid container direction="row" justifyContent="flex-start" spacing={1}>
            <Grid
              item
              style={{
                width: "16%",
              }}
            >
              <Dropdown
                isOpen={dropdownOpen1}
                toggle={toggle1}
                style={{
                  width: "100%",
                }}
              >
                <DropdownToggle
                  caret
                  color="outline-dark"
                  style={{
                    width: "100%",
                  }}
                >
                  <font size="2">
                    <strong> AMOUNT </strong>{" "}
                  </font>{" "}
                </DropdownToggle>{" "}
                <DropdownMenu className="btn-width300">
                  <DropdownItem header> Amount </DropdownItem>{" "}
                  <form className="form-row ml-2">
                    <div className="col-5">
                      <TextField
                        label="Min"
                        variant="outlined"
                        type="text"
                        id="min_value"
                        name="min_value"
                        value={state.min_value}
                        onChange={onMinFilterBy}
                        autoFocus={true}
                        className={classNames("form-control", {
                          "is-invalid": state.errors.min_value,
                        })}
                      />{" "}
                    </div>{" "}
                    <div className="col-1 mt-3">
                      <strong> -- </strong>{" "}
                    </div>{" "}
                    <div className="col-5">
                      <TextField
                        label="Max"
                        variant="outlined"
                        type="text"
                        id="max_value"
                        name="max_value"
                        value={state.max_value}
                        onChange={onMaxFilterBy}
                        className={classNames("form-control", {
                          "is-invalid": state.errors.max_value,
                        })}
                      />{" "}
                      <br />
                    </div>{" "}
                    <div className="col-12">
                      <br />
                    </div>{" "}
                  </form>{" "}
                </DropdownMenu>{" "}
              </Dropdown>{" "}
            </Grid>{" "}
            <Grid
              item
              style={{
                width: "16%",
              }}
            >
              <Dropdown
                isOpen={dropdownOpen2}
                toggle={toggle2}
                style={{
                  width: "100%",
                }}
              >
                <DropdownToggle
                  caret
                  color="outline-dark"
                  style={{
                    width: "100%",
                  }}
                >
                  <font size="2">
                    <strong> DUE DATE </strong>{" "}
                  </font>{" "}
                </DropdownToggle>{" "}
                <DropdownMenu className="btn-width300">
                  <DropdownItem header> Due date </DropdownItem>{" "}
                  <form className="form-row ml-2">
                    <Row
                      style={{
                        margin: "1rem auto",
                      }}
                    >
                      <TextField
                        label="Day"
                        variant="outlined"
                        type="text"
                        id="day_value"
                        name="day_value"
                        value={state.day_value}
                        onChange={onDayFilterBy}
                        autoFocus={true}
                        size="small"
                        className={classNames("form-control col-3", {
                          "is-invalid": state.errors.day_value,
                        })}
                      />{" "}
                      <Dropdown
                        direction="up"
                        isOpen={dropdownOpen5}
                        toggle={toggle5}
                      >
                        <DropdownToggle
                          color="outline-secondary"
                          className="btn-width110"
                          style={{
                            height: 40,
                          }}
                        >
                          {monthSelected.length > 0 ? (
                            <span> {monthSelected} </span>
                          ) : (
                            <span> Month </span>
                          )}{" "}
                        </DropdownToggle>{" "}
                        <DropdownMenu className="btn-width150">
                          <DropdownItem header> Month </DropdownItem>{" "}
                          {calendarMonth.map((each, index) => {
                            return (
                              <DropdownItem
                                key={index}
                                onClick={() => setMonthSelected(each)}
                              >
                                {each}{" "}
                              </DropdownItem>
                            );
                          })}{" "}
                        </DropdownMenu>{" "}
                      </Dropdown>{" "}
                      <TextField
                        label="Year"
                        variant="outlined"
                        type="text"
                        id="year_value"
                        name="year_value"
                        value={state.year_value}
                        onChange={onYearFilterBy}
                        size="small"
                        className={classNames("form-control col-4", {
                          "is-invalid": state.errors.year_value,
                        })}
                      />{" "}
                    </Row>{" "}
                    <div className="col-12 mt-2">
                      <DatePicker
                        selected={dateSelected}
                        onChange={(date) => onDateSelected(date)}
                        customInput={<CustomInput />}
                      />{" "}
                    </div>{" "}
                  </form>{" "}
                </DropdownMenu>{" "}
              </Dropdown>{" "}
            </Grid>{" "}
            <Grid
              item
              style={{
                width: "16%",
              }}
            >
              <Dropdown
                isOpen={dropdownOpen3}
                toggle={toggle3}
                style={{
                  width: "100%",
                }}
              >
                <DropdownToggle
                  caret
                  color="outline-dark"
                  style={{
                    width: "100%",
                  }}
                >
                  <font size="2">
                    <strong> REASON </strong>{" "}
                  </font>{" "}
                </DropdownToggle>{" "}
                <DropdownMenu className="btn-width450">
                  <DropdownItem header> Reason </DropdownItem>{" "}
                  {reasonList ? (
                    <Fragment>
                      {" "}
                      {reasonList.map((each, index) => {
                        return (
                          <div key={index} className="col-12">
                            <Label check>
                              <Checkbox
                                color="primary"
                                type="checkbox"
                                checked={reasonSelected.includes(index + 1)}
                                onChange={() =>
                                  onReasonCheckboxBtnClick(index + 1)
                                }
                              />{" "}
                              {each}{" "}
                            </Label>{" "}
                          </div>
                        );
                      })}{" "}
                    </Fragment>
                  ) : (
                    <Fragment> </Fragment>
                  )}{" "}
                </DropdownMenu>{" "}
              </Dropdown>{" "}
            </Grid>{" "}
            <Grid
              item
              style={{
                width: "16%",
              }}
            >
              <Dropdown
                isOpen={dropdownOpen4}
                toggle={toggle4}
                style={{
                  width: "100%",
                }}
              >
                <DropdownToggle
                  caret
                  color="outline-dark"
                  style={{
                    width: "100%",
                  }}
                >
                  <font size="2">
                    <strong> CASE TYPE </strong>{" "}
                  </font>{" "}
                </DropdownToggle>{" "}
                <DropdownMenu className="btn-width200">
                  <DropdownItem header> Case type </DropdownItem>{" "}
                  <div className="col-12">
                    <Label check>
                      <Checkbox
                        color="primary"
                        type="checkbox"
                        checked={caseSelected.includes(1)}
                        onChange={() => onCaseCheckboxBtnClick(1)}
                      />
                      Internal{" "}
                    </Label>{" "}
                  </div>{" "}
                  <div className="col-12">
                    <Label check>
                      <Checkbox
                        color="primary"
                        type="checkbox"
                        checked={caseSelected.includes(2)}
                        onChange={() => onCaseCheckboxBtnClick(2)}
                      />
                      External{" "}
                    </Label>{" "}
                  </div>{" "}
                </DropdownMenu>{" "}
              </Dropdown>{" "}
            </Grid>{" "}
            <Grid
              item
              style={{
                width: "21%",
              }}
            >
              <Dropdown
                isOpen={dropdownOpen6}
                toggle={toggle6}
                style={{
                  width: "100%",
                }}
              >
                <DropdownToggle
                  caret
                  color="outline-dark"
                  style={{
                    width: "100%",
                  }}
                >
                  <font size="2">
                    <strong> MESSAGES AND CLAIMS </strong>{" "}
                  </font>{" "}
                </DropdownToggle>{" "}
                <DropdownMenu className="btn-width250">
                  <DropdownItem header> Messages and Claims </DropdownItem>{" "}
                  <div className="col-12">
                    <Label check>
                      <Checkbox
                        color="primary"
                        type="checkbox"
                        checked={messagesClaimsSelected.includes(2)}
                        onChange={() => onMessagesAndClaimsCheckboxBtnClick(2)}
                      />
                      Messages{" "}
                    </Label>{" "}
                  </div>{" "}
                  <div className="col-12">
                    <Label check>
                      <Checkbox
                        color="primary"
                        type="checkbox"
                        checked={messagesClaimsSelected.includes(1)}
                        onChange={() => onMessagesAndClaimsCheckboxBtnClick(1)}
                      />
                      Claims{" "}
                    </Label>{" "}
                  </div>{" "}
                </DropdownMenu>{" "}
              </Dropdown>{" "}
            </Grid>{" "}
            <Grid
              item
              style={{
                width: "15%",
              }}
            >
              {" "}
              {/* Clear filter Button*/}{" "}
              <Button
                variant="outlined"
                type="button"
                onClick={clearFilter}
                style={{
                  width: "100%",
                  backgroundColor: "#f6f6f6",
                }}
                className={classes.buttonOutline}
                startIcon={<RefreshIcon />}
              >
                <font size="2">
                  <strong> Clear All </strong>{" "}
                </font>{" "}
              </Button>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Grid>{" "}
    </Paper>
  );
};

export default DisputeFilter;
